import { useEffect, useState } from "react";

import Home from "../pages/Home";
import MyPost from "../pages/MyPost";
import Feed from "../pages/Feed";
import Moment from "../pages/Moment";
import MyMediaPost from "../pages/MyMediaPost";
import Notifications from "../pages/Notifications";
import UserInfoOverlay from "../components/UserInfoOverlay";

export default function DesktopSocialLayout({
  mobileView,
  isSocialView,
  isPostPage,
  currentUser,
  activeTab,
  setActiveTab,
  handleLogout,
  TABS,
  myChatId,
  users,
  groups,
  myPosts,
  commentedPosts,
  globalLivePosts,
  followingPosts,
  myUserName,
   myDisplayName,
  handleOpenPost,
  feedSocket,
  uploadFeedMedia,
  interactionsBadgeCount,
  notificationsBadgeCount,
  notificationCounts,
  commentsByPost,
  feedActionSocket,
  onViewPost,
  setDefaultTab,
  uswdWallet,
  // infinite scroll — feed
  onLoadMoreFeed,
  onLoadMoreGlobal,
  onLoadMoreInteractions,
  feedHasMore,
  feedLoading,
  globalHasMore,
  globalLoading,
  interactionHasMore,
  interactionLoading,
  // 🆕 infinite scroll — my posts
   mediaSocket,
  onLoadMoreMyPosts,
  myPostsHasMore,
  myPostsLoading,
   viewedPostsUser,
  viewedAuthorPosts,
  onExitAuthorPosts,
    handleOpenGroupFromUserInfo,

    // 🎬 Moment (Media)
globalMediaLivePosts,
followingMediaPosts,
commentedMediaPosts,
myMediaPosts,
mediaCommentsByPost,
mediaNotifications,
viewedMediaPostsUser,
viewedAuthorMediaPosts,
onExitAuthorMediaPosts,
fetchMediaPosts,
fetchGlobalMediaPosts,
}) {
  // Hooks must run before the early returns below.
   const [profileUser, setProfileUser] = useState(null);

  // Close User Info whenever the tab changes.
  useEffect(() => {
    setProfileUser(null);
  }, [activeTab]);

  if (mobileView) return null;
  if (!isSocialView) return null;

  const avatarUrl =
    currentUser?.profileImageUrl ||
    currentUser?.avatarUrl ||
    null;

  // Opens the UserInfoOverlay for the author whose avatar was tapped in Moment.
   const handleOpenProfile = (user) => {
    if (!user) return;
    setProfileUser(user);
  };

  // Opens the UserInfoOverlay for the viewer's own profile (top-right avatar in Moment).
  const handleOpenMyProfile = () => {
    setProfileUser({
      chatId: myChatId,
      username: myUserName,
      displayName: myDisplayName,
      profileImageUrl: avatarUrl,
    });
 
      };

  // Media posts for whoever's profile is open — always filtered to THAT user
  // (same logic as getMediaPostsForUser in MobileAppLayout.js)
  const getMediaPostsForUser = (user) => {
    if (!user) return [];
    const uid = String(user.chatId);
    const byId = new Map();

    [myMediaPosts, followingMediaPosts, globalMediaLivePosts, commentedMediaPosts]
      .forEach((list) => {
        (list || []).forEach((p) => {
          if (!p?.postId) return;
          if (String(p.author?.chatId ?? p.chatId) !== uid) return;
          byId.set(p.postId, p);
        });
      });

    return [...byId.values()];
  };

  return (
    <div
      className="flex-1 h-full"
      style={{ display: isPostPage ? "none" : "flex" }}
    >
      {/* LEFT — HOME */}
      <div className="w-[340px] flex-none border-r border-neutral-200 dark:border-neutral-700">
     <Home
  currentUser={currentUser}
  myChatId={myChatId}
  groups={groups}
  feedSocket={feedSocket}
  handleOpenGroupFromUserInfo={handleOpenGroupFromUserInfo}
  myUserName={myUserName}
  myDisplayName={myDisplayName}
  activeTab={
    activeTab === TABS.INTERACTIONS ||
    activeTab === TABS.NOTIFICATIONS
      ? TABS.FEED
      : activeTab
  }
  setActiveTab={setActiveTab}
  onLogout={handleLogout}
  interactionsBadgeCount={interactionsBadgeCount}
  notificationsBadgeCount={notificationsBadgeCount}
/>
      </div>

      {/* CENTER COLUMN */}
      <div className="relative flex-1 max-w-[640px] border-r border-neutral-200 dark:border-neutral-700 overflow-hidden">

        {/* MAIN FEED */}
        <div
          className="absolute inset-0"
          style={{
            visibility: activeTab === TABS.FEED ? "visible" : "hidden",
            pointerEvents: activeTab === TABS.FEED ? "auto" : "none",
          }}
        >
          <Feed
            TABS={TABS}
            mode="main"
            myChatId={myChatId}
            currentUser={currentUser}
            groups={[]}
            groupMembers={{}}
            socket={feedSocket}
            uploadImage={undefined}
            myUserName={myUserName}
            myDisplayName={myDisplayName}
            users={users}
            feedPosts={globalLivePosts}
            followingPosts={followingPosts}
            onCreatePost={feedSocket.createPost}
            uswdWallet={uswdWallet}
            onLikePost={feedSocket.likePost}
            onAddComment={feedSocket.addComment}
            onRepost={feedSocket.repostPost}
            onSupportPost={feedSocket.supportPost}
            onSupportComment={feedSocket.supportComment}
            onUploadMedia={uploadFeedMedia}
            onDeletePost={feedActionSocket?.deletePost}
            onEditPost={feedActionSocket?.editPost}
            onReportPost={feedActionSocket?.reportPost}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            avatarUrl={avatarUrl}
            onViewPost={onViewPost}
            feedSocket={feedSocket}
            setDefaultTab={setDefaultTab}
            onLogout={handleLogout}
            onLoadMoreFeed={onLoadMoreFeed}
            onLoadMoreGlobal={onLoadMoreGlobal}
            feedHasMore={feedHasMore}
            feedLoading={feedLoading}
            globalHasMore={globalHasMore}
            globalLoading={globalLoading}
            interactionsBadgeCount={interactionsBadgeCount}
            notificationsBadgeCount={notificationsBadgeCount}
          />
        </div>


        {/* MY POSTS */}
        <div
          className="absolute inset-0"
          style={{
            visibility: activeTab === TABS.MY_POSTS ? "visible" : "hidden",
            pointerEvents: activeTab === TABS.MY_POSTS ? "auto" : "none",
          }}
        >
          <MyPost
            myChatId={myChatId}
            users={users}
            myPosts={viewedPostsUser ? viewedAuthorPosts : myPosts}
            viewedUser={viewedPostsUser}
            avatarUrl={avatarUrl}
            myDisplayName={myDisplayName}
            onLikePost={feedSocket.likePost}
            onSupportPost={feedSocket.supportPost}
            onSupportComment={feedSocket.supportComment}
            onRepost={feedSocket.repostPost}
            onDeletePost={feedActionSocket.deletePost}
            onEditPost={feedActionSocket.editPost}
            onReportPost={feedActionSocket?.reportPost}
            feedSocket={feedSocket}
            onLoadMore={viewedPostsUser ? undefined : onLoadMoreMyPosts}
            hasMore={viewedPostsUser ? false : myPostsHasMore}
            loading={viewedPostsUser ? false : myPostsLoading}
            uswdWallet={uswdWallet}
            onBack={onExitAuthorPosts}
          />
        </div>

        {/* INTERACTIONS */}
        <div
          className="absolute inset-0"
          style={{
            visibility: activeTab === TABS.INTERACTIONS ? "visible" : "hidden",
            pointerEvents: activeTab === TABS.INTERACTIONS ? "auto" : "none",
          }}
        >
          <Feed
            TABS={TABS}
            mode="commented"
            myChatId={myChatId}
            currentUser={currentUser}
            groups={[]}
            groupMembers={{}}
            socket={feedSocket}
            uploadImage={undefined}
            onViewPost={handleOpenPost}
            myUserName={myUserName}
            myDisplayName={myDisplayName}
            users={users}
            feedPosts={commentedPosts}
            followingPosts={[]}
            onSupportPost={feedSocket.supportPost}
            onSupportComment={feedSocket.supportComment}
            onCreatePost={feedSocket.createPost}
            onLikePost={feedSocket.likePost}
            onAddComment={feedSocket.addComment}
            onRepost={feedSocket.repostPost}
            onUploadMedia={uploadFeedMedia}
            onDeletePost={feedActionSocket.deletePost}
            onEditPost={feedActionSocket.editPost}
            onReportPost={feedActionSocket.reportPost}
            activeTab={activeTab}
            uswdWallet={uswdWallet}
            setActiveTab={setActiveTab}
            avatarUrl={avatarUrl}
            feedSocket={feedSocket}
            onLoadMoreInteractions={onLoadMoreInteractions}
            interactionHasMore={interactionHasMore}
            interactionLoading={interactionLoading}
            interactionsBadgeCount={interactionsBadgeCount}
            notificationsBadgeCount={notificationsBadgeCount}
          />
        </div>

        {/* NOTIFICATIONS */}
        <div
          className="absolute inset-0"
          style={{
            visibility: activeTab === TABS.NOTIFICATIONS ? "visible" : "hidden",
            pointerEvents: activeTab === TABS.NOTIFICATIONS ? "auto" : "none",
          }}
        >
          <Notifications
            notificationCounts={notificationCounts}
            posts={[...globalLivePosts, ...followingPosts]}
            users={users}
            myChatId={myChatId}
            currentUser={currentUser}
            groups={[]}
            groupMembers={{}}
            socket={feedSocket}
            uploadImage={undefined}
            myDisplayName={myDisplayName}
            commentsByPost={commentsByPost}
            onBack={() => setActiveTab(TABS.FEED)}
          />
        </div>

        {/* MOMENT (Media) */}
        <div
          className="absolute inset-0"
          style={{
            visibility: activeTab === TABS.MOMENT ? "visible" : "hidden",
            pointerEvents: activeTab === TABS.MOMENT ? "auto" : "none",
          }}
        >
          <Moment
            TABS={TABS}
            mode="main"
            myChatId={myChatId}
            currentUser={currentUser}
            groups={[]}
            groupMembers={{}}
            myUserName={myUserName}
            myDisplayName={myDisplayName}
            users={users}
            uswdWallet={uswdWallet}
            fetchMediaPosts={fetchMediaPosts}
            fetchGlobalMediaPosts={fetchGlobalMediaPosts}
            mediaPosts={globalMediaLivePosts}
            followingMediaPosts={followingMediaPosts}
            commentedMediaPosts={commentedMediaPosts}
            myMediaPosts={myMediaPosts}
            mediaNotifications={mediaNotifications}
             mediaCommentsByPost={mediaCommentsByPost}
            viewedMediaPostsUser={viewedMediaPostsUser}
            viewedAuthorMediaPosts={viewedAuthorMediaPosts}
            onExitAuthorMediaPosts={onExitAuthorMediaPosts}
            onUploadMedia={uploadFeedMedia}
            onCreateMediaPost={mediaSocket?.mediaCreatePost}
            onLikeMediaPost={mediaSocket?.mediaLikePost}
            onAddMediaComment={mediaSocket?.mediaAddComment}
                       onTrackMediaView={mediaSocket?.mediaTrackView}
            onTrackMediaCommentView={mediaSocket?.mediaTrackView}
            onLikeMediaComment={mediaSocket?.mediaLikeComment}
            onClearMediaNotifications={mediaSocket?.mediaClearNotifications}
            onSupportMediaPost={mediaSocket?.mediaSupportPost}
            mediaSocket={mediaSocket}
            activeTab={activeTab}
              suspended={!!profileUser}
            onAvatarClick={handleOpenProfile}
                      onMyAvatarClick={handleOpenMyProfile}
            setActiveTab={setActiveTab}
            avatarUrl={avatarUrl}
            setDefaultTab={setDefaultTab}
            onLogout={handleLogout}
          />
        </div>

        {/* MY MEDIA POSTS */}
        <div
          className="absolute inset-0"
          style={{
            visibility: activeTab === TABS.MY_MEDIA_POSTS ? "visible" : "hidden",
            pointerEvents: activeTab === TABS.MY_MEDIA_POSTS ? "auto" : "none",
          }}
        >
          <MyMediaPost
            myChatId={myChatId}
            myUserName={myUserName}
            myDisplayName={myDisplayName}
            currentUser={currentUser}
            avatarUrl={avatarUrl}
            users={users}
            myMediaPosts={viewedMediaPostsUser ? viewedAuthorMediaPosts : myMediaPosts}
            viewedUser={viewedMediaPostsUser}
            mediaCommentsByPost={mediaCommentsByPost}
            onLikeMediaPost={mediaSocket?.mediaLikePost}
            onAddMediaComment={mediaSocket?.mediaAddComment}
            onLikeMediaComment={mediaSocket?.mediaLikeComment}
            onSupportMediaPost={mediaSocket?.mediaSupportPost}
           onTrackMediaView={mediaSocket.mediaTrackView}
    onTrackMediaCommentView={mediaSocket.mediaTrackView}
            onBack={() => {
              onExitAuthorMediaPosts?.();
              setActiveTab(TABS.MOMENT);
            }}
          />
        </div>

      </div>

      {/* RIGHT COLUMN — SEARCH */}
      <div className="hidden lg:block w-[350px] p-4">
        <div className="sticky top-4">
          <div className="relative">
            <input
              id="global-search"
              name="global-search"
              type="text"
              placeholder="Search"
              autoComplete="off"
              className="w-full rounded-full bg-neutral-100 dark:bg-neutral-700 px-4 py-2 pl-10 text-sm outline-none focus:ring-2 focus:ring-blue-500"
            />
            <span className="absolute left-3 top-2.5 text-neutral-400">🔍</span>
          </div>

          <div className="mt-6 rounded-2xl bg-neutral-100 dark:bg-neutral-700 p-4">
            <div className="font-semibold mb-3">What's happening</div>
            <div className="text-sm text-neutral-500">Trends coming soon…</div>
          </div>
        </div>
      </div>

      {/* USER INFO OVERLAY — opened from the author avatar in Moment.
          UserInfoOverlay renders through createPortal into <body>, so
          where it sits in this tree doesn't affect its stacking. */}
             <UserInfoOverlay
        open={!!profileUser}
        onClose={() => setProfileUser(null)}
        user={profileUser}
        initialTab="media"
        myChatId={myChatId}
        mutualGroups={[]}
        onOpenGroup={handleOpenGroupFromUserInfo}
        viewedUser={profileUser}
        currentUser={currentUser}
        avatarUrl={avatarUrl}
        myUserName={myUserName}
        myDisplayName={myDisplayName}
        users={users}
               myMediaPosts={getMediaPostsForUser(profileUser)}
        mediaCommentsByPost={mediaCommentsByPost}
        mediaSocket={mediaSocket}
      />
    </div>
  );
}